import { create } from "zustand";

const useAppStore = create((set) => ({
  settings: {
    activeTab: "general",
    point_value: 5,
    point_value_expire_at: "",
  },
  setSettings: (settings) =>
    set((state) => ({
      settings: {
        ...state.settings,
        ...settings,
      },
    })),
}));

export default useAppStore;
